<template>
  <div id="warehouse-canceled-register-payment-method-page" class="payment">
    <div class="text-center">
      <h1 class="payment-title">お支払い方法の登録をキャンセルしました。</h1>
    </div>
    <div class="payment-content">
      <div>
        お手続きありがとうございます。<br>
        セラー様の操作により、お支払い方法の登録をキャンセルしました。
      </div>
      <div class="m-t-xl m-b-xl">
        ご利用になる場合は、倉庫管理画面よりお手続きをお願いいたします。
      </div>
      <div class="box-link-to-warehouse m-b-lg">
        <router-link to="/Warehouses" class="link-to-warehouse">倉庫管理はこちら</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseService from '@/services/warehouseservice'
import LoadingBlock from '@/components/LoadingBlock'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    LoadingBlock
  },
  data () {
    return {
      sessionId: null,
      loader: null
    }
  },
  created () {
    this.sessionId = this.$route.query.session_id
    if (!this.sessionId) {
      this.$router.push('/not-found')
    }
  },
  methods: {
    cancelCheckoutSession () {
      this.loader = this.$loading.show()
      WarehouseService.cancelCheckoutSession({session_id: this.sessionId})
        .then(response => {
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    }
  },
  mounted () {
    this.cancelCheckoutSession()
    let logParams = {
      name: eventCode.warehouses.show_canceled_register_payment_method_page,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouses/CanceledRegisterPaymentMethod.vue